import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../../decorators'
import { getLeadSourceContactListData } from './mockData'
import type { ILeadSourceContact } from '~/types/contact/models'

// get

interface GetLeadSourceContactsResponse {
  data: ILeadSourceContact[]
}

async function getLeadSourceContacts(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetLeadSourceContactsResponse = {
    data: await getLeadSourceContactListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postLeadSourceContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getLeadSourceContactListData)
}

const patchLeadSourceContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getLeadSourceContactListData)
}

const deleteLeadSourceContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getLeadSourceContactListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/leadsourcecontacts',
    handler: getLeadSourceContacts,
  },
  {
    method: 'post',
    path: '/api/leadsourcecontacts',
    handler: postLeadSourceContact,
  },
  {
    method: 'patch',
    path: '/api/leadsourcecontacts/:id',
    handler: patchLeadSourceContact,
  },
  {
    method: 'delete',
    path: '/api/leadsourcecontacts/:id',
    handler: deleteLeadSourceContact,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
